angular.module('SpidApp')

.factory('Order', ['OrderItem',
function (OrderItem) {
        var Order = function () {
            this.objects = []
            this.recu = null
            this.order_id = 0
            this.status = null
            this.validated = false
            this.nbProduct = 0
            this.nbProductOp = 0
        }

        Order.prototype.STATUS_CREATE = '0'
        Order.prototype.STATUS_CANCEL = '1'
        Order.prototype.STATUS_TODO = '2'
        Order.prototype.STATUS_IN_PROGRESS = '3'
        Order.prototype.STATUS_SEND_PART = '4'
        Order.prototype.STATUS_SEND = '5'
        Order.prototype.STATUS_RECEIVE_PART = '6'
        Order.prototype.STATUS_RECEIVE = '7'
        Order.prototype.STATUS_CLOSE = '8'

        Order.prototype.setUnvalidated = function () {
            this.validated = false
        }

        Order.prototype.setValidated = function () {
            if (!this.isValidable()) {
                throw 'Order::setValidated() - Order is not in a validable state'
            }

            this.validated = true
        }

        Order.prototype.setStatusCreate = function () {
            this.status = this.STATUS_CREATE
        }

        Order.prototype.setStatusCancel = function () {
            this.status = this.STATUS_CANCEL
        }

        Order.prototype.setStatusTodo = function () {
            this.status = this.STATUS_TODO
        }

        Order.prototype.setStatusReceivePartially = function () {
            this.status = this.STATUS_RECEIVE_PART
        }

        Order.prototype.setStatusReceiveTotally = function () {
            this.status = this.STATUS_RECEIVE
        }

        Order.prototype.flush = function () {
            Order.call(this)
        }

        Order.prototype.isEmpty = function () {
            return !this.objects || this.objects.length === 0
        }

        Order.prototype.removeOrderItem = function (index) {
            if (this.isValidated()) {
                throw 'Order::removeOrderItem() - Order is already validated'
            }

            if (index === null || index === undefined || index < 0) {
                throw "Order::removeOrderItem() - Malformed parameters"
            }

            this.objects.splice(index, 1);
        }

        Order.prototype._addOrderItem = function (orderItem) {
            if (this.isValidated()) {
                throw 'Order::_addOrderItem() - Order is already validated'
            }

            this.objects.push(orderItem)
        }

        Order.prototype.incrementOrderItemQuantity = function (orderItem) {
            if (this.isValidated()) {
                throw 'Order::incrementOrderItemQuantity() - Order is already validated'
            }

            if (!orderItem) {
                throw 'Order::incrementOrderItemQuantity() - Missing parameters'
            }

            orderItem.incrementQuantity()
        }

        Order.prototype.decrementOrderItemQuantity = function (orderItem) {
            if (this.isValidated()) {
                throw 'Order::decrementOrderItemQuantity() - Order is already validated'
            }

            if (!orderItem) {
                throw 'Order::decrementOrderItemQuantity() - Missing parameters'
            }

            orderItem.decrementQuantity()
        }

        Order.prototype.incrementQuantityGet = function (orderItem) {
            orderItem.incrementQuantityGet()
        }

        Order.prototype.decrementQuantityGet = function (orderItem) {
            orderItem.decrementQuantityGet()
        }

        Order.prototype.addProduct = function (product, quantity) {
            if (this.isValidated()) {
                throw 'Order::addProduct() - Order is already validated'
            }

            if (!product) {
                throw 'Order::addProduct() - Missing parameters'
            }

            var previousInstance = _.chain(this.objects).find(function (o) {
                return o.id === product.id
            }).value()

            if (!previousInstance) {
                var orderItem = new OrderItem(OrderItem.PRODUCT, _.extend(product, {
                    quantity: quantity
                }))
                this._addOrderItem(orderItem)
            } else {
                previousInstance.quantity += quantity
            }
        }

        Order.prototype.addOperationalProduct = function (product, quantity) {
            if (this.isValidated()) {
                throw 'Cart::addOperationalProduct() - Cart is already validated'
            }

            if (!product) {
                throw 'Cart::addOperationalProduct() - Missing parameters'
            }

            var previousInstance = _.chain(this.objects).find(function (o) {
                return o.id === product.id
            }).value()

            if (!previousInstance) {
                var orderItem = new OrderItem(OrderItem.OPERATIONAL_PRODUCT, _.extend(product, {
                    quantity: quantity
                }))
                this._addOrderItem(orderItem)
            } else {
                previousInstance.quantity = +previousInstance.quantity + (+quantity)
            }
        }

        Order.prototype.getContent = function () {
            return this.objects
        }

        Order.prototype.isValidable = function () {
            return !this.isEmpty()
        }

        Order.prototype.isValidated = function () {
            return this.validated
        }

        Order.prototype.restaureFromDb = function (data) {
            this.order_id = data[0].orders_id;
            this.lot = data[0].lot;
            if (data[0].lastStatus) {
                this.status = data[0].lastStatus.status;
            }

            this.aStatus = data[0].aStatus;

            for (var items in data[0].items) {
                if(data[0].items.hasOwnProperty(items)) {
                    var itemType = data[0].items[items].obj_table_ref;
                    var product = {
                        id: data[0].items[items].obj_id,
                        label: data[0].items[items].label
                    };
                    this.addProductFromRestaure(product, data[0].items[items], itemType);
                }
            }
        }

        Order.prototype.addProductFromRestaure = function (product, item, itemType) {

            var previousInstance = _.chain(this.objects).find(function (o) {
                return o.id === product.id
            }).value()

            if (!previousInstance) {
                var orderItem = new OrderItem(itemType, _.extend(product, {
                    quantity: item.unit,
                    quantity_send: item.quantity_send,
                    quantity_get: item.quantity_get
                }))
                this._addOrderItem(orderItem)
            } else {
                previousInstance.quantity += item.unit
                previousInstance.quantity_send += item.quantity_send
                previousInstance.quantity_get += item.quantity_get
            }
        }

        var OrderSingleton = {
            _instance: null,
            getInstance: function () {
                if (!this._instance) {
                    this._instance = new Order()
                }

                return this._instance
            }
        }

        return OrderSingleton
}])
